import { FunctionalComponent } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import { GetServerSideProps } from '../../../../server-middleware/context'
import { z } from 'zod'
import getConfig from '@insided/deprecated-services/configCommunity'
// eslint-disable-next-line import/no-internal-modules
import WidgetContainer, { widgetContainerConfig } from '@insided/deprecated-preact-components/widget-container'
import GenericHeroContainer from './GenericHeroContainer'

export const widgetName = 'generic_hero'

export const heroAlignment = ['left', 'center'] as const

export const config = z
  .object({
    heroImage: z.string().optional(),
    headline: z.string().optional(),
    tagline: z.string().optional(),
    align: z.enum(heroAlignment).optional()
  })
  .merge(widgetContainerConfig)

export type GenericHeroConfig = z.infer<typeof config>

interface Props extends GenericHeroConfig, SearchScope {}

export const getServerSideProps: GetServerSideProps<GenericHeroConfig, Props> = async (context, config) => {
  const isFederatedSalesforceSearch = await getConfig(context, 'salesforceFederatedSearchEnabled')
  const { heroImage, title, subtitle, headline, tagline } = config
  const { skilljar, freshdesk } = context.config.config.params

  return {
    heroImage,
    title,
    subtitle,
    headline,
    tagline,
    isFederatedSalesforceSearch: isFederatedSalesforceSearch,
    isFederatedSkilljarSearch: skilljar?.enabledFederatedSearch ?? false,
    isFederatedFreshdeskSearch: freshdesk?.enabledFederatedSearch ?? false
  }
}

const GenericHero: FunctionalComponent<Props> = ({
  align,
  backgroundColor,
  backgroundColorDisplay,
  title,
  subtitle,
  heroImage,
  isFederatedSalesforceSearch,
  isFederatedSkilljarSearch,
  isFederatedFreshdeskSearch,
  tagline,
  headline
}) => {
  const centered = align === 'center'

  return (
    <WidgetContainer
      widgetName='generic_hero'
      noSpacing
      noSideMargins
      config={{
        // we do not pass title/subtitle to the container
        // TODO: Introduce parameter noTitle and noSubtitle to be able to pass the whole config
        // or another, more sustainable approach
        backgroundColorDisplay: backgroundColorDisplay,
        backgroundColor: backgroundColor
      }}
    >
      <GenericHeroContainer
        centered={centered}
        title={title ?? headline}
        subtitle={subtitle ?? tagline}
        heroImage={heroImage}
        isFederatedSalesforceSearch={isFederatedSalesforceSearch}
        isFederatedSkilljarSearch={isFederatedSkilljarSearch}
        isFederatedFreshdeskSearch={isFederatedFreshdeskSearch}
      />
    </WidgetContainer>
  )
}

export default GenericHero
